window.toggleHeading = function() {
  const elements = document.getElementsByClassName("kg-toggle-heading");

  function handleClick(event) {
    const toggleCard = event.target.closest(".kg-toggle-card");
    if (!toggleCard) return; // If no toggle card is found, return early
    const toggleState = toggleCard.getAttribute("data-kg-toggle-state");
    toggleCard.setAttribute("data-kg-toggle-state", toggleState === "close" ? "open" : "close");
  }

  for (let i = 0; i < elements.length; i++) {
    elements[i].addEventListener("click", handleClick, false);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  toggleHeading();
});
